export default __webpack_public_path__ + "static/media/SG-Red-0001.1756236b.png";